import type { PublicPraise } from '@cult/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';
import { praiseKey } from './use-praise';

export const useDeletePraise = () => {
  const queryClient = useQueryClient();
  return useMutation<void, Error, PublicPraise>({
    // Mutations address the praise by uuid; the detail cache is keyed by its public number.
    mutationFn: async (praise) => {
      await apiFetch<unknown>(`/praises/${praise.id}`, { method: 'DELETE' });
    },
    onSuccess: (_data, praise) => {
      queryClient.removeQueries({ queryKey: praiseKey(String(praise.number)) });
      queryClient.invalidateQueries({ queryKey: ['praises'], exact: false });
    },
  });
};
